module.exports = __webpack_public_path__ + "img/seaPalace-3.87431406.jpg";